module.exports = __webpack_public_path__ + "static/media/mark.accb3798.svg";